import React, { useState } from "react";
import { ButtonBase, colors, Grid, Hidden, Typography } from "@material-ui/core";
import Barcode from "react-barcode/lib/react-barcode";
import { sto } from "../../../../../Context/InshData";
import BarcodeImg from "./BarcodeImg";
import { useTranslation } from "react-i18next";

function BarcodeItemsFoundDate(props) {
    const { t } = useTranslation(["forms"]);
    const { barcode, itemName, price, maqas, permiCuCo,
        tax, AutoOptions, showLogo, showItem, data, prody_date, expiry_date, } = props;
    let Item_Price = price;

    if (permiCuCo == 0 && tax!=0) {
        Item_Price = (price + (price * tax) / 100).toFixed(2);
    } else {
        Item_Price = price;
    }
    // Item_Price = (price + (price * tax) / 100).toFixed(2);

    const width = 2.6;
    const hight = 40;

    return (
        <div justifyCo2tent="center" style={{
            minWidth: `${maqas.wisthPaper}mm`,
            maxWidth: `${maqas.wisthPaper}mm`,
            minHeight: '20mm',
            textAlign: "center",
            backgroundColor: "#fff",
            paddingTop: `${maqas?.margnTop}mm`,
            paddingBottom: `${maqas?.margnBottom}mm`,
        }}>
            <BarcodeImg {...{ AutoOptions, showLogo, showItem, data }} />
            <div justifyContent="center" style={{
                direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, marginLeft: "0.1rem"
                , marginRight: "0.1rem", fontSize: "1.1rem", marginTop: "0.1rem", alignContent: "center"
            }}
            > {AutoOptions?.Found[0]?.nameA}</div>
            <div style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 2, fontSize: "1rem", }}> {itemName}</div>
            <div
                style={{
                    minWidth: '50mm',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    fontSize: '25px',
                    fontWeight: "bold"
                    , backgroundColor: '#fff',
                }}
            >
                <Barcode style={{ fontWeight: "bold" }} value={barcode} width={width} height={hight} />

            </div>
            <div style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "1.4rem"  }}>{Item_Price}{""}{t("sar")}</div>

            <Grid
                container
                xs={12}
                style={{ fontSize: "8px", }} >
                <Grid item xs={6} style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "1.1rem" }}>
                    {"PRO   "}{prody_date}
                </Grid>
                <Grid item xs={6} style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "1.1rem" }}>
                    {"EXP   "} {expiry_date}
                </Grid>
            </Grid>
        </div>
    );
}

export default BarcodeItemsFoundDate;
